module.exports = __webpack_public_path__ + "static/fonts/OsBarlow.903ba0f4.ttf";